/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum API_ERROR_NAME {
	UNEXPECTED_ERROR = "internal",
	AUTH_INVALID_TOKEN = "authInvalidToken",
	AUTH_NO_TOKEN = "authNoToken",
	AUTH_NOT_LOGGED_IN = "authNotLoggedIn",
	AUTH_FORBIDDEN = "authForbidden",
	APP_NOT_FOUND = "appNotFound",
	FEATURE_NOT_AVAILABLE = "featureNotAvailable"
}

/**
 * API Error class
 */
export class ApiError extends Error {
	public constructor(public name: API_ERROR_NAME, message: string, public sourceError?: Error) {
		super(message);
	}
}
